// A credit popup (HUBX-8504): one line per sentence; {orderAmount} and {availableCredit} in a line are shown in bold
export interface CreditAlert {
  title: string;
  lines: string[];
  availableCredit?: number;
  orderAmount?: number;
}

// A credit popup with the title of the action that failed. The lines are a text of environment.creditAlert, where
// {subject} becomes order or offer.
export function creditAlert(title: string, lines: string[], subject: 'order' | 'offer',
                            availableCredit?: number, orderAmount?: number): CreditAlert {
  return {
    title,
    availableCredit,
    orderAmount,
    lines: lines.map(line => line.replace('{subject}', subject))
  };
}
